import axios from 'axios'

const attachment = {}
// 删除附件
attachment.del = params => { return axios.get('/video/file/del', {params}) }
// 查询附件
attachment.find = params => { return axios.get('/video/file/find', {params}) }
// 上传附件
attachment.upload = params => { return axios.post('/video/file/upload', params, { headers: { 'Content-Type': 'multipart/form-data' } })}

export default attachment



// WEBPACK FOOTER //
// ./src/api/attachment.js